import caiso from './caiso';

const miso: any = { misoMenu: /miso:*/, ...caiso };

export default miso;